import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PathFinderGameCoreService } from './path-finder-game-core.service';
import { PathFinderGameSelectorComponent } from './path-finder-game-selector/path-finder-game-selector.component';

@NgModule({
  declarations: [PathFinderGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [PathFinderGameCoreService],
  exports: [PathFinderGameSelectorComponent],
})
export class PathFinderGameCoreModule {}
